import React from 'react'
import { array } from 'prop-types'

import Hide from '@/component/Primitive/Hide'
import Stack from '@/component/Primitive/Stack'
import Grid from '@/component/Primitive/Grid'
import Title from '@/component/Primitive/Title'
import Carousel from '@/component/Primitive/Carousel'
import MagazineCover from '@/component/Primitive/MagazineCover'

const PastMagazineIssuesWidget = ({ magazineIssues }) => {
  return (
    <Stack>
      <Title title="Latest Editions" bordered="default" />
      <Hide below="desktop">
        <Grid gutter="default">
          {magazineIssues.map((item, i) => (
            <Grid.Item trailingGap="default" key={i} width={{ d: 1 / 4 }}>
              <MagazineCover {...item} />
            </Grid.Item>
          ))}
        </Grid>
      </Hide>
      <Hide at="desktop">
        <Carousel>
          {magazineIssues.map((item, i) => (
            <MagazineCover {...item} key={i} />
          ))}
        </Carousel>
      </Hide>
    </Stack>
  )
}

PastMagazineIssuesWidget.propTypes = {
  magazineIssues: array
}

export default PastMagazineIssuesWidget
